import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { FiCheck, FiX } from 'react-icons/fi';

const calculateRotation = (value, bipolar) =>
   bipolar ? value * 120 : value * 240 - 120;

const KnobDisplay = forwardRef(
   (
      {
         value,
         x,
         y,
         diameter,
         bipolar,
         onMouseDown,
         isActive,
         disabled,
         ghost,
         notApplicable,
         tested,
         correct,
         highlighted,
         suggestedValue,
      },
      ref
   ) => {
      const r = diameter / 2;

      const svgSize = diameter > 32 ? 16 : 12;

      const rotation = calculateRotation(value, bipolar);

      const suggestedRotation = calculateRotation(suggestedValue, bipolar);
      // const iconY =
      //    y + (rotation > -90 && rotation < 90 ? diameter - svgSize : 0);
      const iconY = y + diameter / 2 - svgSize / 2;
      return (
         <g
            className={classNames('knob', {
               active: isActive,
               disabled: disabled || notApplicable,
               ghost,
               'not-applicable': notApplicable,
               correct: tested && correct,
               incorrect: tested && !correct,
               highlighted,
            })}
            ref={ref}
            onMouseDown={onMouseDown}
         >
            {(highlighted || suggestedValue != null) && (
               <circle
                  className="knob-highlight"
                  r={r + 4}
                  cx={x + r}
                  cy={y + r}
               />
            )}
            <g
               className="knob-rotate"
               style={{
                  transform: `rotate(${rotation}deg)`,
                  transformBox: 'fill-box',
                  transformOrigin: 'center',
               }}
            >
               <circle className="knob-body" r={r} cx={x + r} cy={y + r} />
               {/* <rect
                  className="knob-position-indicator"
                  width={2}
                  x={x + r - 1}
                  y={y + 3}
                  height={diameter / 3}
                  rx={1}
               /> */}
               <circle
                  className="knob-position-indicator"
                  r={2}
                  cx={x + r}
                  cy={y + 5}
               />
            </g>

            <FiX
               className="incorrect-icon"
               size={svgSize}
               x={x + diameter / 2 - svgSize / 2}
               y={iconY}
            />

            <FiCheck
               className="correct-icon"
               size={svgSize}
               x={x + diameter / 2 - svgSize / 2}
               y={iconY}
            />

            {suggestedValue != null && (
               <g
                  style={{
                     transform: `rotate(${suggestedRotation}deg)`,
                     transformBox: 'fill-box',
                     transformOrigin: 'center',
                  }}
               >
                  <circle fill="none" r={r + 11} cx={x + r} cy={y + r} />
                  {/* <circle
                     className="knob-position-indicator"
                     r={4}
                     cx={x + r}
                     cy={y + 5}
                  /> */}
                  {/* <polygon
                     className="knob-position-indicator"
                     points={`${x + r} ${y + 9}, ${x + r + 3} ${y + 19}, ${
                        x + r - 3
                     } ${y + 19}`}
                  /> */}
                  <polygon
                     className="knob-suggestion-indicator"
                     points={`${x + r} ${y}, ${x + r + 3} ${y - 10}, ${
                        x + r - 3
                     } ${y - 10}`}
                  />
               </g>
            )}
         </g>
      );
   }
);

export { KnobDisplay };
